import { Component, OnInit, Input, Inject, LOCALE_ID } from "@angular/core";
import { CommonService } from "../../services/common/common.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  @Input() pathname: any = "";
  currentYear: String = "";

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formatDate();
  }

  public getRedirectionLink(type: string) {
    switch (type) {
      case "privacy_policy":
        return this.pathname
          ? "/" + this.locale + "/info/privacy-policy?referer=" + this.pathname
          : "/" + this.locale + "/info/privacy-policy";

      case "terms_conditions":
        return this.pathname
          ? "/" +
              this.locale +
              "/info/terms-and-conditions?referer=" +
              this.pathname
          : "/" + this.locale + "/info/terms-and-conditions";

      case "customer_support":
        return this.pathname
          ? "/" +
              this.locale +
              "/info/customer-support?referer=" +
              this.pathname
          : "/" + this.locale + "/info/customer-support";
    }
  }

  public analyticsLinkData(type: string) {
    const redirectionLink = this.getRedirectionLink(type);

    const pageURL = window.location.origin + redirectionLink;

    const payload = {
      siteSection: "footer",
      button_name: type,
      pageURL: pageURL,
      linkType: "navigation",
      clickPosition: "footer",
    };
    this.commonService.sendAnalyticsData("home_click", "clickInfo", payload);
  }

  formatDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.currentYear = year.toString();
  }
}
